/**
 * @fileoverview โหลด Google Maps ผ่าน useJsApiLoader ตัวเดียวกับคอมโพเนนต์แผนที่อื่น
 * ใช้แทน <LoadScript> ในหน้า class component — LoadScript ไม่ render ลูกถ้ามี window.google อยู่แล้ว
 * (เช่นเปิดแผนที่ GPS ในใบงานก่อน) และตอน unmount ลบ script ทิ้งทำให้แผนที่หน้าอื่นต้องโหลดใหม่
 * @module components/maps/MapsLoader
 */
import React from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import { t } from '../CustomComponent';
import { GOOGLE_MAPS_API_KEY, GOOGLE_MAPS_LIBRARIES, GOOGLE_MAPS_LOADER_ID } from '../../utils/googleMaps';

export default function MapsLoader({ children }) {
  const { isLoaded, loadError } = useJsApiLoader({
    id: GOOGLE_MAPS_LOADER_ID,
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
  });
  if (loadError) {
    return <div className="d-flex align-items-center justify-content-center h-100 text-muted">{t('map_load_failed')}</div>;
  }
  if (!isLoaded) return null;
  return <>{children}</>;
}
